



















































import { Component, Vue, Prop, Watch } from "vue-property-decorator"
import draggable from "vuedraggable"
import OPERATORS from '@/constants/operators'

@Component({
  components: {
    draggable,
  },
})
export default class QuestionConditionExpressionSelect extends Vue {
  @Prop({ type: String }) conditionExpression!: string
  @Prop() items!: Model[]

  get conditionExp() {
    return this.conditionExpression
  }
  set conditionExp(v) {
    this.$emit("update:condition-expression", v)
  }

  localValue: Record<string, string>[] = []

  newTag = ""
  isInputShown = false
  operators = OPERATORS

  get tags() {
    return this.operators.map(tag => ({
      label: tag,
      value: tag
    }))
  }

  beforeMount() {
    // Refactor the condition expression value
    if (this.conditionExpression && this.conditionExpression.length > 0) {
      const tmp = this.conditionExpression.split(" ")
      for (const item of tmp) {
        this.localValue.push({
          label: item,
          value: item,
        })
      }
    }
  }

  @Watch('localValue')
  watchLocalValue(newVal) {
    const value = newVal.map((item) => {
      return item.value
    })
    this.conditionExp = value.join(" ")
  }

  addTag(tag) {
    this.localValue.push(tag)
  }

  handleClose(tag) {
    this.localValue.splice(this.localValue.indexOf(tag), 1)
  }

  // Display input field for adding new tag
  showInput() {
    this.isInputShown = true
    this.$nextTick(() => {
      (this.$refs.newTagInput as { $refs }).$refs.input.focus()
    })
  }

  // Insert new tag into the list
  handleInputConfirm() {
    if (this.newTag) {
      this.localValue.push({
        value: this.newTag,
        label: this.newTag,
      })
    }
    this.isInputShown = false
    this.newTag = ""
  }

  findItem(oid) {
    return this.items.find(item => item.object_id === oid)
  }

  mapItemText(item) {
    if (!item) {
      return ""
    }
    return `${item.object_id} - ${this.convertToText(item.source_type)} - ${this.convertToText(item.matching_operator)} - ${this.convertToText(item.matching_value)}`
  }

  convertToText(slug) {
    if (!slug) {
      return ""
    }
    const slugString = slug.toString()
    return slugString.charAt(0).toUpperCase() + slugString.slice(1).replace("_", " ")
  }
}
